import { ADD_TO_WISHLIST, REMOVE_FROM_WISHLIST } from "../actions/type";

// 🧾 Define Product Type
export interface WishlistProduct {
  id: number | string;
  title?: string;
  [key: string]: any; // For flexibility (e.g., price, image, etc.)
}

// 🧾 Define Action Types
interface AddToWishlistAction {
  type: typeof ADD_TO_WISHLIST;
  product: WishlistProduct;
}

interface RemoveFromWishlistAction {
  type: typeof REMOVE_FROM_WISHLIST;
  id: number | string;
}

type WishlistAction = AddToWishlistAction | RemoveFromWishlistAction;

// 🧾 Define State
export interface WishlistState {
  w_list: WishlistProduct[];
}

const initialState: WishlistState = {
  w_list: [],
};

// 🧠 Pure Reducer (No Toast Here)
export const wishListReducer = (
  state: WishlistState = initialState,
  action: WishlistAction
): WishlistState => {
  switch (action.type) {
    case ADD_TO_WISHLIST: {
      const productId = action.product.id;

      // Toggle behavior — add or remove item
      if (state.w_list.some((product) => product.id === productId)) {
        return {
          ...state,
          w_list: state.w_list.filter((product) => product.id !== productId),
        };
      }

      return {
        ...state,
        w_list: [...state.w_list, action.product],
      };
    }

    case REMOVE_FROM_WISHLIST:
      return {
        ...state,
        w_list: state.w_list.filter((product) => product.id !== action.id),
      };

    default:
      return state;
  }
};

export default wishListReducer;
